export default __webpack_public_path__ + "static/media/oto.6a6a4671.png";